import React from 'react';
import { useTranslation } from 'react-i18next';
import HeroImage from '../../../../assets/images/services/banking-license/hero-image.png'
import PageBanner from '../../../../assets/images/services/banking-license/page-banner.png'

import BreadCrumbs from "../../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../../components/Constant/List/List";
import { GiCheckMark } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../../components/Constant/cta/CTA";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../../components/Constant/button/Button";
import SEO from "../../../../utils/SEO";

function WesternSaharaBankingLicense () {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.western-sahara-banking-license.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });
    const withIcon = (k, icon) => (obj(k) || []).map((it) => ({ ...it, icon }));
    const dots = (k) => (obj(k) || []).map((paragraph) => ({ paragraph, icon: GoDotFill }));

    const BreadCrumbsData = [
        { name: tp('breadcrumb.home', 'Offshore Advisory'), link: '/' },
        { name: tp('breadcrumb.self', 'Western Sahara Banking License'), link: '/banking-license' },
    ];

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/western-sahara-banking-license"
            />

            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>

                    <h1 className='section-title'>{tp('h1')}</h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>{tp('subtitle')}</h3>
                            <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('intro') }} />
                            <PageList items={withIcon('introList', GiCheckMark)} />
                            <Button
                                text={tp('proposalButton')}
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <BannerPageImg src={PageBanner} />
                    <b/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>{tp('whyTitle')}</h3>

                        <h3 className='page-title'>{tp('typesTitle1')}</h3>
                        <PageList items={withIcon('whyItems', GoDotFill)} />

                        <h3 className='page-title'>{tp('typesTitle2')}</h3>
                        <h4 className='page-subtitle'>{tp('classI.heading')}</h4>
                        <p dangerouslySetInnerHTML={{ __html: tp('classI.desc') }} />
                        <p className='page-subtitle'>{tp('classI.capitalLabel')}</p>
                        <PageList items={dots('classI.capital')} />
                        <p className='page-subtitle'>{tp('classI.benefitsLabel')}</p>
                        <PageList items={withIcon('classI.benefits', GoDotFill)} />

                        <h4 className='page-subtitle'>{tp('classII.heading')}</h4>
                        <p dangerouslySetInnerHTML={{ __html: tp('classII.desc') }} />
                        <p className='page-subtitle'>{tp('classII.capitalLabel')}</p>
                        <PageList items={dots('classII.capital')} />
                        <p className='page-subtitle'>{tp('classII.benefitsLabel')}</p>
                        <PageList items={withIcon('classII.benefits', GoDotFill)} />

                        <hr className='section-divider'/>

                        <h3 className='page-title'>{tp('process.title')}</h3>
                        <PageList items={withIcon('process.items', GoDotFill)} />

                        <hr className='section-divider'/>

                        <h3 className='page-title'>{tp('timeline.title')}</h3>
                        <PageList items={withIcon('timeline.items', GoDotFill)} />

                        <hr className='section-divider'/>

                        <h3 className='page-title'>{tp('whyUs.title')}</h3>
                        <PageList items={withIcon('whyUs.items', GoDotFill)} />
                    </div>

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>
                    <Testimonials
                        title={tp('testimonials.title')}
                        testimonials={obj('testimonials.items')}
                    />
                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    );
}

export default WesternSaharaBankingLicense;
